import {
  useUrlFilterState,
  useUrlRangeState,
  useUrlSortingState,
} from '../../../common/filtering/filters';
import { useState } from 'react';
import { DashboardViewLayout } from '../../../components/DashboardViewLayout';
import { DripEmail, DripEmailWithContact } from '../../../common/types';
import { DripEmailTable } from '../../../components/dashboard/DripEmailTable';
import { Button, SpaceBetween } from '@cloudscape-design/components';
import { sendDripEmails } from '../../../common/api/dripEmails';
import { useMutation } from '@tanstack/react-query';
import {
  DripScopeFilter,
  useUrlDripScope,
} from '../../../components/dashboard/DripScopeFilter';

export default function View() {
  const { query, setQuery } = useUrlFilterState();
  const [textQuery, setTextQuery] = useState('');
  const past = true;
  const { sortingField, setSortingField, sortDirection, setSortDirection } = useUrlSortingState(
    'scheduled_at',
    'desc',
  );
  const { range, setRange } = useUrlRangeState(past);
  const [now, setNow] = useState(new Date());
  const [selectedItems, setSelectedItems] = useState<DripEmailWithContact[]>([]);
  const { scope, setCampaignUuid, setZipBlastUuid } = useUrlDripScope();

  const resourceName = 'Drip Emails';

  const sendMutation = useMutation({
    mutationFn: sendDripEmails,
    onSuccess: () => {
      setSelectedItems([]);
      setNow(new Date(new Date().getTime() + 1000));
    },
  });

  const send = () => {
    sendMutation.mutate(selectedItems.map((item) => item.uuid));
  };

  return (
    <DashboardViewLayout breadcrumbs={[{ text: resourceName, href: '' }]} contentType="table">
      <DripEmailTable
        now={now}
        setNow={setNow}
        query={query}
        setQuery={setQuery}
        range={range}
        setRange={setRange}
        sortingField={sortingField}
        setSortingField={setSortingField}
        sortDirection={sortDirection}
        setSortDirection={setSortDirection}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        textQuery={textQuery}
        setTextQuery={setTextQuery}
        scope={scope}
        additionalActions={
          <SpaceBetween size="xs" direction="horizontal">
            <DripScopeFilter
              scope={scope}
              setCampaignUuid={setCampaignUuid}
              setZipBlastUuid={setZipBlastUuid}
            />
            <Button
              variant="primary"
              iconName="send"
              onClick={send}
              disabled={selectedItems.length === 0}
              loading={sendMutation.isPending}
            >
              Send Immediately
            </Button>
          </SpaceBetween>
        }
      />
    </DashboardViewLayout>
  );
}
